// extracted by mini-css-extract-plugin
module.exports = {"productDetail":"ProductHeader_productDetail__2fVnK","sellerText":"ProductHeader_sellerText__1cKTV","sellerHeading":"ProductHeader_sellerHeading__1CMYe"};